import client, { REWARDS_BASE_URL } from 'services/kardAPI';

const fetchMerchants = async (filters = '') => {
  try {
    const merchants = await client.get(
      `${REWARDS_BASE_URL}/portal/merchant${filters}`,
    );
    return merchants.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export default fetchMerchants;
